import { render, staticRenderFns } from "./EditUserDepartments.vue?vue&type=template&id=da3a89c6&scoped=true&"
import script from "./EditUserDepartments.vue?vue&type=script&lang=js&"
export * from "./EditUserDepartments.vue?vue&type=script&lang=js&"
import style0 from "./EditUserDepartments.vue?vue&type=style&index=0&id=da3a89c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da3a89c6",
  null
  
)

export default component.exports